import * as React from "react";
import { Dispatch } from "redux";
import { clearSectionNotifications, shouldClearSectionNotifications } from "../../redux/middleware/clearSectionNotificationsMiddleware";

interface ISectionNotificationResetProps {
    location: { pathname: string };
    portalType: string;
    dispatch: Dispatch;
}

export class SectionNotificationReset extends React.Component<ISectionNotificationResetProps> {
    componentDidUpdate(prevProps: ISectionNotificationResetProps) {
        const { dispatch, portalType, location } = this.props;

        if (!shouldClearSectionNotifications(portalType, prevProps.location?.pathname, location?.pathname)) {
            return;
        }

        clearSectionNotifications(dispatch);
    }

    render() {
        return null;
    }
}
